import React, { FC, ReactNode } from 'react'
import { usePopperTooltip, TriggerType } from 'react-popper-tooltip'

export interface TooltipProps {
  text: string
  placement:
    | 'auto'
    | 'auto-start'
    | 'auto-end'
    | 'top'
    | 'top-start'
    | 'top-end'
    | 'bottom'
    | 'bottom-start'
    | 'bottom-end'
    | 'right'
    | 'right-start'
    | 'right-end'
    | 'left'
    | 'left-start'
    | 'left-end'
  delay: number
  trigger: TriggerType | TriggerType[] | null
  distance: number
  hidden: boolean
  className?: string
  children: ReactNode
}

const Tooltip: FC<TooltipProps> = ({
  text,
  placement = 'top',
  delay = 350,
  trigger = 'hover',
  distance = 4,
  hidden = false,
  className = '',
  children
}) => {
  const { getTooltipProps, setTooltipRef, setTriggerRef, visible } =
    usePopperTooltip({
      delayShow: delay,
      offset: [0, distance],
      placement,
      trigger
    })

  if (hidden) {
    return <>{children}</>
  }

  return (
    <>
      <div
        className="inline-block"
        ref={setTriggerRef}
      >
        {children}
      </div>
      {visible && (
        <div
          ref={setTooltipRef}
          {...getTooltipProps({
            className: `hidden max-w-[224px] rounded-lg border border-gray-300 bg-white px-3 py-2 text-xs 
          text-gray-900 shadow-md lg:block ${className}`
          })}
        >
          {text}
        </div>
      )}
    </>
  )
}

export default Tooltip
